import { createContext } from 'react';

import type { DrawerConfirmationOptions, Layer, LayerStoreState } from './layerStoreReducer';

export interface DrawerGuard {
    hasUnsavedChanges: boolean;
    isBusy?: boolean;
}

interface DrawerContextType {
    store: LayerStoreState;
    busyLayerIds: ReadonlySet<number>;
    push: (layer: Layer) => number;
    pop: (id?: number) => void;
    requestClose: (id?: number, onClose?: () => void) => void;
    confirm: (options: DrawerConfirmationOptions, id?: number) => Promise<boolean>;
    resolveConfirmation: (id: number, confirmed: boolean) => void;
    registerGuard: (id: number, guard: DrawerGuard) => () => void;
}

const missingProvider = (): never => {
    throw new Error("Must be called within a DrawerContextProvider's child");
};

export const DrawerContext = createContext<DrawerContextType>({
    store: { layers: [] },
    busyLayerIds: new Set(),
    push: missingProvider,
    pop: missingProvider,
    requestClose: missingProvider,
    confirm: missingProvider,
    resolveConfirmation: missingProvider,
    registerGuard: missingProvider,
});
